export const stringIncludes = (search: string | number, from: string | number) => {
  const reg = new RegExp(String(search));
  return reg.test(String(from));
};
